import React from "react";
import { ShieldCheckIcon, LockIcon, ZapIcon, WalletIcon } from "lucide-react";
type TrustRowProps = {
  variant?: "hero" | "checkout";
  inverted?: boolean;
};
export function TrustRow({
  variant = "checkout",
  inverted = false
}: TrustRowProps) {
  const items = variant === "hero" ? [{
    icon: ShieldCheckIcon,
    label: "Garantía 7 días"
  }, {
    icon: LockIcon,
    label: "Pago seguro"
  }, {
    icon: WalletIcon,
    label: "Mercado Pago"
  }] : [{
    icon: LockIcon,
    label: "Pago seguro"
  }, {
    icon: ZapIcon,
    label: "Acceso en 5 min"
  }, {
    icon: ShieldCheckIcon,
    label: "Garantía 7 días"
  }, {
    icon: WalletIcon,
    label: "Mercado Pago"
  }];
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-xs sm:justify-start md:gap-x-5 md:text-[13px] ${inverted ? "text-paper/75" : "text-muted"}`} data-id="element-317" data-mp="1txbskj1sjvt5">
      {items.map(({
      icon: Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-318" data-mp="35geh4gfvx00c">
          <Icon className={`h-3.5 w-3.5 md:h-4 md:w-4 ${inverted ? "text-gold" : "text-forest"}`} aria-hidden data-id="element-319" data-mp="3fwh58u83hpu5" />
          {label}
        </li>)}
    </ul>;
}